import { useCallback } from 'react'
import { feedback } from '../../../core/feedback'
import { requests } from '../../../core/ajax'
import { useIntl } from 'react-intl'

export const useUsersCalls = () => {
  const { formatMessage } = useIntl()

  const noResponseError = () =>
    feedback('error', formatMessage({ id: 'calls.responseless.error.description' }))
  const defaultError = () =>
    feedback('error', formatMessage({ id: 'calls.default.error.description' }))

  const getUsers = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        requests
          .users(config)
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                feedback('error', response.data.message)
                break
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const getUsersStatusCount = useCallback(
    () =>
      new Promise((resolve, reject) => {
        requests
          .usersStatusCount()
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                feedback('error', response.data.message)
                break
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const requestUsersExport = useCallback(
    (data) =>
      new Promise((resolve, reject) => {
        requests
          .usersExport(data)
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                feedback('error', response.data.message)
                break
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getUsers,
    getUsersStatusCount,
    requestUsersExport,
  }
}
